import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store =  new Vuex.Store({
  state: {
    selectVid:'',                 /*  */
    isSearchBox: true,
    isLangPanel1: false,
    isLangPanel2: false,
    jpListData: [],
    dicMaster: [],
    wordData: [],                 /* 単語の明細データ */
    isSubMenu: false,             /* サブメニューの表示（true)  */
    subMenuData: [],               /* サブメニューの表示データ */
    subMenuImage:'',              /* サブメニューに表示するイメージ */
    isTopBoke: false,             /* 画面をボケを適用の可否 True : 適用 */
    content: '',
    listType: '',                 /* リストタイプ  1: 日本語 2:琉球語 */
    isDspWide:false,              /* 広げる戻すの表示をするかのフラグ */
    isWide: false,                  /* 広げる／縮めるの動作  */
    isSearchLeft: false,
    isGuide:false,                /* ガイドを表示するか  */
    pageAllCnt:1,
    pageNo: 1,                    /* 選択したページ */
    pageCurrentNo: 1,             /* 表示中のページ */
    allCnt: 0,
    errMessage: '',                 /* エラーメッセージ */
    isCompView: false,              /* 比較ダイアログを表示するかのフラグ */
    compData:[],                    /* 比較データ */
    selListData:[]                  /* リストで選択したデータ */

  },
  getters: {
    selectVid(state) {            /* 選択中のVID */
      return state.selectVid;
    },
    wordData(state) {             /* 表示中の語彙(メイン) */
      return state.wordData;
    },
    isSearchBox(state) {          /* 検索画面の表示・非表示 */
      return state.isSearchBox;
    },
    jpListData(state) {
      return state.jpListData;
    },
    isLangPanel1(state) {
      return state.isLangPanel1;
    },
    isLangPanel2(state) {
      return state.isLangPanel2;
    },
    dicMaster(state) {          /* 辞書マスタ */
      return state.dicMaster;
    },
    isSubMenu(state) {          /* サブメニュの表示非表示 */
      return state.isSubMenu;
    },
    isTopBoke(state) {
      return state.isTopBoke;
    },
    content(state) {
      return state.content;
    },
    listType(state) {
      return state.listType;
    },
    isDspWide(state) {
      return state.isDspWide;
    },
    isWide(state) {             /* 詳細を広げる */
      return state.isWide;
    },
    isSearchLeft(state) {
      return state.isSearchLeft;
    },
    pageNo(state) {           /* ページNO */
      return state.pageNo;
    },
    pageAllCnt(state) {
      return state.pageAllCnt;
    },
    pageCurrentNo(state) {
      return state.pageCurrentNo;
    },
    allCnt(state) {
      return state.allCnt;
    },
    subMenuData(state) {
      return state.subMenuData;
    },
    subMenuImage(state) {
      return state.subMenuImage;
    },
    isGuide(state) {
      return state.isGuide;
    },
    errMessage(state) {
      return state.errMessage;
    },
    isCompView(state) {
      return state.isCompView;
    },
    compData(state) {
      return state.compData;
    },
    selListData(state) {
        return state.selListData;
      }

    


   

  },
  mutations: {
    setSelectVid(state, payload) {
      state.selectVid = payload.selectVid;
    },
    setWordData(state, payload) {
      state.wordData = payload.wordData;
    },
    setIsSearchBox(state, payload) {
      state.isSearchBox = payload.isSearchBox;
    },
    setJpListData(state, payload) {
      state.jpListData = payload.jpListData;
    },
    setIsLangPanel1(state, payload) {
      state.isLangPanel1 = payload.isLangPanel1;
    },
    setIsLangPanel2(state, payload) {
      state.isLangPanel2 = payload.isLangPanel2;
    },
    setDicMaster(state, payload) {
      state.dicMaster = payload.dicMaster;
    },
    setIsSubMenu(state, payload) {
      state.isSubMenu = payload.isSubMenu;
    },
    setIsTopBoke(state, payload) {
      state.isTopBoke = payload.isTopBoke;
    },
    setContent(state, payload) {
      state.content = payload.content;
    },
    setListType(state, payload) {
      state.listType = payload.listType;
    },
    setIsDspWide(state, payload) {
      state.isDspWide = payload.isDspWide;
    },
    setIsWide(state, payload) {
      state.isWide = payload.isWide;
    },
    setIsSearchLeft(state, payload) {
      state.isSearchLeft = payload.isSearchLeft;
    },
    setPageNo(state, payload) {
      state.pageNo = payload.pageNo;
    },
    setPageAllCnt(state, payload) {
      state.pageAllCnt = payload.pageAllCnt;
    },
    setPageCurrentNo(state, payload) {
      state.pageCurrentNo = payload.pageCurrentNo;
    },
    setAllCnt(state, payload) {
      state.allCnt = payload.allCnt;
    },
    setSubMenuData(state, payload) {
      state.subMenuData = payload.subMenuData;
    },
    setSubMenuImage(state, payload) {
      state.subMenuImage = payload.subMenuImage;
    },
    setIsGuide(state, payload) {
      state.isGuide = payload.isGuide;
    },
    setErrMessage(state, payload) {
      state.errMessage = payload.errMessage;
    },
    setIsCompView(state, payload) {
      state.isCompView = payload.isCompView;
    },
    setCompData(state, payload) {
      state.compData = payload.compData;
    },
    setSelListData(state, payload) {
        state.selListData = payload.selListData;
      }
    

  },
  actions: {
    upSelectVid({ commit }, selectVid) {
      commit('setSelectVid', { selectVid });
    },
    upWordData({ commit }, wordData) {
      commit('setWordData', { wordData });
    },
    upIsSearchBox({ commit }, isSearchBox) {
      commit('setIsSearchBox', { isSearchBox });
    },
    upJpListData({ commit }, jpListData) {
      commit('setJpListData', { jpListData });
    },
    upIsLangPanel1({ commit }, isLangPanel1) {
      commit('setIsLangPanel1', { isLangPanel1 });
    },
    upIsLangPanel2({ commit }, isLangPanel2) {
      commit('setIsLangPanel2', { isLangPanel2 });
    },
    upDicMaster({ commit }, dicMaster) {
      commit('setDicMaster', { dicMaster });
    },
    upIsSubMenu({ commit }, isSubMenu) {
      commit('setIsSubMenu', { isSubMenu });
    },
    upIsTopBoke({ commit }, isTopBoke) {
      commit('setIsTopBoke', { isTopBoke });
    },
    upContent({ commit }, content) {
      commit('setContent', { content });
    },
    upListType({ commit }, listType) {
      commit('setListType', { listType });
    },
    upIsDspWide({ commit }, isDspWide) {
      commit('setIsDspWide', { isDspWide });
    },
    upIsWide({ commit }, isWide) {
      commit('setIsWide', { isWide });
    },
    upIsSearchLeft({ commit }, isSearchLeft) {
      commit('setIsSearchLeft', { isSearchLeft });
    },
    upPageNo({ commit }, pageNo) {
      commit('setPageNo', { pageNo });
    },
    upPageAllCnt({ commit }, pageAllCnt) {
      commit('setPageAllCnt', { pageAllCnt });
    },
    upPageCurrentNo({ commit }, pageCurrentNo) {
      commit('setPageCurrentNo', { pageCurrentNo });
    },
    upAllCnt({ commit }, allCnt) {
      commit('setAllCnt', { allCnt });
    },
    upSubMenuData({ commit }, subMenuData) {
      commit('setSubMenuData', { subMenuData });
    },
    upSubMenuImage({ commit }, subMenuImage) {
      commit('setSubMenuImage', { subMenuImage });
    },
    upIsGuide({ commit }, isGuide) {
      commit('setIsGuide', { isGuide });
    },
    upErrMessage({ commit }, errMessage) {
      commit('setErrMessage',{ errMessage });
    },
    upIsCompView({ commit }, isCompView) {
      commit('setIsCompView', { isCompView });
    },
    upCompData({ commit }, compData) {
      commit('setCompData', { compData });
    },
    upSelListData({ commit }, selListData) {
        commit('setSelListData', { selListData });
      }



  }
})

export default store